
<div :class="[classes(n('--content')), classes(n(`--content--confirm`))]">
  <div
    v-for="(chunkedSetting, i) in data"
    :key="i"
    :class="classes(n(`--content--confirm--column${i}`))"
  >
    <div
      v-for="(keysSetting, j) in chunkedSetting"
      :key="`keyboard-column-${j}`"
      :class="[classes(n(`--content--confirm--item`)),classes(n(`--content--confirm--column${i}--item`))]"
    >
      <div
        v-for="item in keysSetting"
        :key="item.key"
        :class="[n(`--content--confirm--item--split`),n(`--content--confirm--column${i}--item--split`),item.className ? n(`--content--confirm--column${i}--item--${item.className}`) : '']"
      >
        <KeyboardItem
          :class="getItemClassList(item)"
          :value="item.key"
          :safe-mode="safeMode"
          :confirm-btn-text="confirmBtnText"
          :confirm-btn-enable="confirmBtnEnable"
          @click="handleClick"
        />
      </div>
    </div>
  </div>
</div>
